import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import AppBar from '@mui/material/AppBar';
import { Typography } from '@mui/material';
import SearchBar from './Searchbar';
import i18n from '../i18n';
import { ApplicationState } from '../store';
import { useSelector } from 'react-redux';


const Participants = (props: any) => {

    const [participantsNbr, setParticipantsNbr] = React.useState<number>(0);
    const userData = useSelector((state: ApplicationState) => state?.appData?.app4legalData);
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    const direction = appLanguage == "ar" ? "rtl" : "ltr";
    const [module, setModule] = React.useState(userData?.module);
    const callbackFunction = (childData: any) => {
        setParticipantsNbr(childData);
    };

    return (<React.Fragment><div dir={direction}>
        <Box sx={{ width: '500px' }}>
            {props.view ? <></> : <AppBar position="static">
                <Toolbar>
                    <Typography
                        variant="h5"
                        noWrap
                        component="div"
                    >
                        {i18n.t('app.participants')} ({module ? participantsNbr ? participantsNbr : 0 : (participantsNbr - 1) ? (participantsNbr - 1) : 0})
                    </Typography>
                </Toolbar>
            </AppBar>}
            <List>
                <SearchBar handleParticipantsClosee={props.handleParticipantsClosee} items={props.inviteesList} invite={!props.view} parentCallback={callbackFunction} getEmails={props.getEmails} />
            </List>
        </Box>
    </div>
    </React.Fragment>
    );
};
export default Participants;